export class EmbedConfig {
    id: any;
    embedUrl: string;
    accessToken: string;
    embedToken: EmbedToken;
    minutesToExpiration: number;
    isEffectiveIdentityRolesRequired: boolean;
    isEffectiveIdentityRequired: boolean;
    enableRLS: boolean;
    username: string;
    roles: string[];
    errorMessage: string;

    constructor() {
        this.embedUrl = '';
        this.accessToken = '';
        this.embedToken = new EmbedToken();
        this.minutesToExpiration = 0;
        this.isEffectiveIdentityRolesRequired = false;
        this.isEffectiveIdentityRequired = false;
        this.enableRLS = false;
        this.username = '';
        this.roles = [];
        this.errorMessage = '';
    }
}

export class EmbedToken {
    token: string;
    tokenId: string;
    expiration: string;

    constructor() {
        this.token = '';
        this.tokenId = '';
        this.expiration = '';
     }
}
